module.exports = __webpack_public_path__ + "static/media/wow6.9e928fa0.mp3";